module.exports = __webpack_public_path__ + "img/newsImg.60c75f9d.jpg";